export default __webpack_public_path__ + "static/media/forward_white.7de5ec0d.svg";